import Vue from '../consts/vue'
import SimpleVueValidator from 'simple-vue-validator'

SimpleVueValidator.setMode('manual')

Vue.use(SimpleVueValidator)
